import { useParams } from "react-router-dom";
import settings from "../../apiConfigs/settings";
import requestAPI from "../../utils/requestAPI";
import {
  AcceptButton,
  ButtonsSection,
  Card,
  LabelText,
  SectionTitle,
  Title,
  ValueText,
  Wrapper,
} from "../Properties/Details/styles";
import { useEffect, useState } from "react";
import { humanReadableDateWithTime } from "../../utils/date";
import {
  renderFullDetails,
  renderstatus,
} from "../../designComponents/Table/renderMethods";
import { UserTypes } from "../Users";
import Modal from "../../designComponents/Modal";
import Typography from "../../designComponents/Typography";
import { S3FetchUrl } from "../../utils/S3FetchPrivateUrl";
interface PropertyPricing {
  priceType: string;
  price: number;
}

interface Contract {
  bookingId: {
    _id: string;
    propertyId: {
      address: string;
      images: string[];
      landlord: UserTypes;
    };
    pricing: {
      price: number;
      priceType: string;
    };
  };
  propertyId: {
    pricing: PropertyPricing;
    _id: string;
  };
  _id: string;
  contractPDF: string;
  contractPDFName: string;
  contractType: string;
  createdAt: string;
  createdBy: UserTypes;
  endDate: string;
  landlordSign: string;
  paymentType: string;
  pricing: PropertyPricing;
  price: number;
  priceType: string;
  securityDeposit: { amount: number; status: string };
  startDate: string;
  status: string;
  tenantId: UserTypes;
  tenantSign: string;
  updatedAt: string;
  __v: number;
}

const Contract = () => {
  const { contractId } = useParams();
  const [contractDetails, setContractDetails] = useState<Contract>();
  const getContractDetails = async (id: string) => {
    const response = await requestAPI(settings.getSingleContract(id));
    setContractDetails(response);
  };
  const [contractUrl, setContractUrl] = useState<string>();
  const getContractUrl = async (key: string) => {
    try {
      const response = await requestAPI(settings.getS3PrivateUrl(key));
      setContractUrl(response);
    } catch (error) {
      console.error("Error fetching private URL:", error);
      return null;
    }
  };
  const [isOpen, setIsOpen] = useState<boolean>(false);
  useEffect(() => {
    if (contractId) {
      getContractDetails(contractId);
    }
  }, [contractId]);
  useEffect(() => {
    if (contractDetails?.contractPDF) {
      const parsedUrl = new URL(contractDetails?.contractPDF);
      const pathParts = parsedUrl.pathname;
      const finalUrl = pathParts.slice(1);
      getContractUrl(finalUrl);
    }
  }, [contractDetails?.contractPDF]);

  return (
    <Wrapper>
      <Title>Contract Detail</Title>
      <Card>
        <SectionTitle>{contractDetails?.contractPDFName}</SectionTitle>
        <ButtonsSection>
          <LabelText>Contract Type</LabelText>
          <ValueText>{contractDetails?.contractType}</ValueText>
        </ButtonsSection>
        <ButtonsSection>
          <LabelText>Signed On</LabelText>
          <ValueText>
            {humanReadableDateWithTime(contractDetails?.createdAt ?? "")}
          </ValueText>
        </ButtonsSection>
        <ButtonsSection>
          <LabelText>Payment Type</LabelText>
          <ValueText>{contractDetails?.paymentType ?? ""}</ValueText>
        </ButtonsSection>
        <ButtonsSection>
          <LabelText>Payment Type</LabelText>
          <ValueText>{contractDetails?.paymentType ?? ""}</ValueText>
        </ButtonsSection>
        <ButtonsSection>
          <LabelText>Contract End Date</LabelText>
          <ValueText>
            {humanReadableDateWithTime(contractDetails?.endDate ?? "")}
          </ValueText>
        </ButtonsSection>
        <ButtonsSection>
          <LabelText>Status</LabelText>
          {renderstatus(contractDetails?.status ?? "")}
        </ButtonsSection>
        <ButtonsSection>
          <LabelText>Security Deposit</LabelText>
          <ValueText>
            € {contractDetails?.securityDeposit?.amount ?? ""}
          </ValueText>
        </ButtonsSection>
        <ButtonsSection>
          <LabelText>Security Deposit Status</LabelText>
          {renderstatus(contractDetails?.securityDeposit?.status) ?? ""}
        </ButtonsSection>
      </Card>
      <Card>
        <ButtonsSection>
          <SectionTitle>Details</SectionTitle>
          <AcceptButton
            onClick={() => {
              setIsOpen(true);
            }}
          >
            Download PDF
          </AcceptButton>
        </ButtonsSection>

        {contractDetails?.contractType !== "MANUAL" && (
          <ButtonsSection>
            <div style={{ display: "flex", gap: 19, flexDirection: "column" }}>
              <LabelText>Tenant</LabelText>
              {renderFullDetails({
                firstName: contractDetails?.tenantId?.firstName,
                lastName: contractDetails?.tenantId?.lastName,
                avatar: contractDetails?.tenantId?.avatar,
                email: contractDetails?.tenantId?.email,
              })}
              {contractDetails?.tenantSign &&
              contractDetails?.tenantSign !== "MANUAL_UPLOAD" ? (
                <img
                  src={contractDetails?.tenantSign}
                  height={130}
                  width={200}
                  alt="tenant signature"
                ></img>
              ) : (
                <div>
                  <Typography>No Signature Yet</Typography>
                </div>
              )}
            </div>
            <div style={{ display: "flex", gap: 19, flexDirection: "column" }}>
              <LabelText>LandLord</LabelText>
              {renderFullDetails({
                firstName:
                  contractDetails?.bookingId.propertyId?.landlord?.firstName,
                lastName:
                  contractDetails?.bookingId.propertyId?.landlord?.lastName,
                avatar: contractDetails?.bookingId.propertyId?.landlord?.avatar,
                email: contractDetails?.bookingId.propertyId?.landlord?.email,
              })}
              {contractDetails?.landlordSign &&
              contractDetails?.landlordSign !== "MANUAL_UPLOAD" ? (
                <img
                  src={contractDetails?.landlordSign}
                  height={130}
                  width={200}
                  alt="landlord signature"
                ></img>
              ) : (
                <div>
                  <Typography>No Signature Yet</Typography>
                </div>
              )}
            </div>
          </ButtonsSection>
        )}
      </Card>
      <Modal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        halfWidth={true}
        title={contractDetails?.contractPDFName}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <iframe
            style={{ minHeight: 600, width: "100%" }}
            src={contractUrl}
            title="Doc"
          ></iframe>
        </div>
      </Modal>
    </Wrapper>
  );
};
export default Contract;
